import React, {Component} from 'react';
import FeedingGuidelinesHeader from './../FeedingGuidelinesHeader';
import FeedingGuidelinesIntro from './../FeedingGuidelinesIntro';
import FeedingGuidelinesProducts from './../FeedingGuidelinesProducts';
import FeedingGuidelinesNotes from './../FeedingGuidelinesNotes';
import FeedingGuidelinesRecommended from './../FeedingGuidelinesRecommended';
import FeedingGuidelinesPersonalizedNutrientProfile from './../FeedingGuidelinesPersonalizedNutrientProfile';
import FeedingGuidelinesDisclaimer from './../FeedingGuidelinesDisclaimer';
import FeedingGuidelinesFoodIntake from './../FeedingGuidelinesFoodIntake';

class Growth extends Component {

  render(){
    const {output} = this.props;

    return (
      <div>
        <FeedingGuidelinesHeader output={output} />
        <FeedingGuidelinesIntro output={output} />
        <FeedingGuidelinesProducts output={output} />
        <FeedingGuidelinesNotes output={output} />
        <FeedingGuidelinesRecommended output={output} />
        <FeedingGuidelinesDisclaimer output={output} />
      </div>
    )
  }

}

export default (Growth);

